/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

const SkinIconOverrideContext = createContext<Record<string, string> | null>(null);

export function SkinIconOverrideProvider({
  value,
  children,
}: {
  value: Record<string, string> | null;
  children: ReactNode;
}) {
  return <SkinIconOverrideContext.Provider value={value}>{children}</SkinIconOverrideContext.Provider>;
}

export function useSkinIconOverride(): Record<string, string> | null {
  return useContext(SkinIconOverrideContext);
}

